export const WA = {
  header: '#027DC2',
  headerDark: '#015A8E',
  accent: '#027DC2',
  fab: '#027DC2',
  send: '#027DC2',
  outgoing: '#D7EEFB',
  incoming: '#FFFFFF',
  chatBg: '#F3F6FA',
  sidebar: '#F8FAFC',
  listHover: '#F1F5F9',
  listActive: '#E8F4FC',
  unread: '#027DC2',
  meta: '#637381',
  inputBar: '#FFFFFF',
  text: '#212B36',
  searchBg: '#EEF2F6',
  border: '#E7ECF1',
  radius: 18,
  shadow: '0 24px 60px rgba(15, 23, 42, 0.16)',
}
